import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import PersonalTraining from "./pages/PersonalTraining";
import StrengthPrograms from "./pages/StrengthPrograms";
import FatLoss from "./pages/FatLoss";
import Supplements from "./pages/Supplements";
import Memberships from "./pages/Memberships";
import Reviews from "./pages/Reviews";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/personal-training" element={<PersonalTraining />} />
          <Route path="/strength-programs" element={<StrengthPrograms />} />
          <Route path="/fat-loss" element={<FatLoss />} />
          <Route path="/supplements" element={<Supplements />} />
          <Route path="/memberships" element={<Memberships />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <WhatsAppFloat />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
